import { render, staticRenderFns } from "./ItemBuyProvisionsList.vue?vue&type=template&id=9daf5066&"
import script from "./ItemBuyProvisionsList.vue?vue&type=script&lang=js&"
export * from "./ItemBuyProvisionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports